import React from "react";
import HandWaveIcon from "@novel/shared/icons/HandWaveIcon.png";
import { Tooltip, Whisper } from "rsuite";
import { OverlayTriggerProps } from "rsuite/esm/Overlay/OverlayTrigger";
import Image from "next/legacy/image";
interface ConditionalTooltipProps {
  readonly show?: boolean;
  readonly preferredPosition?: OverlayTriggerProps["placement"];
  readonly content: React.ReactNode;
  readonly children: React.ReactElement;
}
export function ConditionalTooltip({
  show,
  content,
  preferredPosition = "autoVerticalStart",
  children
}: ConditionalTooltipProps) {
  if (!show) {
    return children;
  }
  while (children.props.content) {
    children = children.props.children;
  }
  return <Whisper placement={preferredPosition} controlId="control-id-hover" trigger={["hover", "click"]} speaker={<Tooltip className="tooltip-flexible-lg">
                    <div className="flex justify-center">
                        <span className="emoji-tooltip-design">
                            <Image src={HandWaveIcon} alt="HandWaveIcon" layout="fixed" />{" "}
                        </span>
                        <span className="text-tooltip-design"> {content}</span>
                    </div>
                </Tooltip>}>
            <div>{children}</div>
        </Whisper>;
}